export default {"src":"/_next/static/media/info-icon.815941c7.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};